<template>
  <div class="Wrapper-Dropdown">
    <div class="Wrapper-Dropdown__hdr" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="Wrapper-Dropdown__scroll-wrapper" :class="get_gradStyles">
      <div class="Wrapper-Dropdown__scroll" :style="get_maxHeight" @scroll="toCheckScroll" ref="scrollBox">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineProps, onMounted, onBeforeUnmount, ref } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  const props = defineProps(Props());  
  const emit = defineEmits();
  //--------------------------
  const isScrollTop = ref(false);
  const isScrollBottom = ref(false);
  const scrollBox = ref(null);
  const resizeObserver = ref({});
  //--------------------------
  onMounted(() => {
    toAddObserver();
    toCheckScroll();
  })
  onBeforeUnmount(() => {
    toRemoveObserver();
  })
  //--------------------------
  //Определить максимальную высоту области видимости
  const get_maxHeight = computed(() => `max-height: ${props.maxHeight}px`);
  //Добавить классы с градиентом для границ скролл бокса
  const get_gradStyles = computed(() => {
    return `
      ${isScrollTop.value ? '' : 'Wrapper-Dropdown__scroll-wrapper--top'}
      ${isScrollBottom.value ? '' : 'Wrapper-Dropdown__scroll-wrapper--bottom'}
    `
  })
  //--------------------------
  //Добавить слушатель событий
  const toAddObserver = () => {
    resizeObserver.value = new ResizeObserver(toCheckScroll);
    resizeObserver.value.observe(scrollBox.value);
  }
  //Убрать слушатели событий
  const toRemoveObserver = () => {
    resizeObserver.value.disconnect();
  }
  //Проверить достиг ли скролл нижней или верхней позиции
  const toCheckScroll = () => {
    const box = scrollBox.value;
    if(!box) return;
    isScrollTop.value = (box.scrollTop <= 10) ? true : false;
    isScrollBottom.value = (box.scrollTop + box.clientHeight >= box.scrollHeight - 10) ? true : false;
    if(isScrollBottom.value) toEmitSignal();
  }
  //Послать сигнал на вверх, что скролл достиг нижней границы
  const toEmitSignal = () => emit('scrollAtEnd');
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>